import PromptEditor from '@/components/PromptEditor.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated } from '@/services/auth'

const routes = [
  // Root goes to the credit app (guard bounces to /login when signed out)
  {
    path: '/',
    redirect: '/app'
  },
  // ATFOOI Website Routes (parked under /landing)
  {
    path: '/landing',
    name: 'Landing',
    component: () => import('../views/Landing.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue')
  },
  {
    path: '/demo',
    name: 'Demo',
    component: () => import('../views/Demo.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  // Existing Application Routes
  {
    path: '/app',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/prompt-editor',
    name: 'PromptEditor',
    component: PromptEditor,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  if (to.path === '/login' && isAuthenticated()) {
    return { path: '/app' }
  }
  return true
})

export default router
